// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const TemplatorService = {
    // Template returns a Template Of its ID.
    // Only returns templates if not marked as deleted (where Template.deleted_at is null).
    Template(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/templator/v1/template/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "GET" });
    },
    // TemplatesCreate creates new templates
    TemplatesCreate(fn, req) {
        return fn(`/messaging/templator/v1`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // TemplatesUpdate allows for minor changes to templates.
    // Only updates templates that are not marked as deleted (where Template.deleted_at is null).
    TemplatesUpdate(fn, req) {
        return fn(`/messaging/templator/v1`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // TemplatesDelete will mark an existing template as deleted.
    TemplatesDelete(fn, req) {
        return fn(`/messaging/templator/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    // TemplatesofLocation returns a slice of templates belonging to given Location.
    // Only returns templates that are not marked as deleted (where Template.deleted_at is null).
    TemplatesOfLocation(fn, req) {
        return fn(`/messaging/templator/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // PreviewTemplateMessage will return a rendered a message based on the provided interpolation data and template
    // The template is not looked up as in RenderMessage(). This will render message as given (no
    // URL shortening or Replay instruction addpending)
    PreviewTemplateMessage(fn, req) {
        return fn(`/messaging/templator/v1/preview`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // PreviewSegmentCounts will take the template_string, append reply instructions and shorten URLs
    // to get an estimated segment count for when the text messages go out. Please note that this
    // endpoint DOES NOT return rendered messages (use PreviewTemplateMessages for rendering).
    // This endpoint will return segment count and encoding per indivual message as well as a total
    // segment count and distinct list of encodings
    PreviewSegmentCounts(fn, req) {
        return fn(`/messaging/templator/v1/preview-segment-counts`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
